const USER_PREFIX = 'USER_';

// Raised before a tenant/app switch request is issued. currentTenantCd keeps the
// outgoing tenant until the switch resolves, so this is what tells guards that wait
// on a hydrated user (AppView's Enigma route, Settings) to stop rendering its data.
export const TENANT_SWITCH_START = USER_PREFIX + 'TENANT_SWITCH_START';
export const FETCH_DATA_SUCCESS = USER_PREFIX + 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = USER_PREFIX + 'FETCH_DATA_FAILURE';

export const LOGIN_SUCCESS = USER_PREFIX + 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = USER_PREFIX + 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

export const BROKER_SET = USER_PREFIX + 'BROKER_SET';

export const APP_SWITCHED = USER_PREFIX + 'APP_SWITCHED';

export const JWT = USER_PREFIX + 'JWT';

export const FETCH_ALL_BROKERS = USER_PREFIX + 'FETCH_ALL_BROKERS';

export const RESET_APPS_TENANT = USER_PREFIX + 'RESET_APPS_TENANT';

export const RESET_APP = USER_PREFIX + 'RESET_APP';

export const SET_AI_SUMMARY_PREFERENCE = USER_PREFIX + 'SET_AI_SUMMARY_PREFERENCE';
export const UPDATE_COMPANY_FEATURES = USER_PREFIX + 'UPDATE_COMPANY_FEATURES';

export const resetAppsTenant = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_APPS_TENANT });
    return Promise.resolve();
  };
};
